import React from 'react';
import { Form } from 'components';
import { EditableRowProps } from './types';
import { EditableContext } from './context';

export const EditableRow: React.FC<EditableRowProps> = ({ editingRow, editingColumn, ...props }) => {
  const [form] = Form.useForm();

  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={{ form, editingRow, editingColumn }}>
        <tr {...(props as any)} />
      </EditableContext.Provider>
    </Form>
  );
};
